<template>
  <div class="btn-group" style="margin:0" data-toggle="buttons">
    <label class="btn btn-default"
           @click="updateValue('Y')"
           :class="{'active': isYes}">
      <input type="radio" value="Y"
             :checked="isYes"/> Yes
    </label>
    <label class="btn btn-default"
           @click="updateValue('N')"
           :class="{'active': value === 'N'}">
      <input type="radio" value="N"
             :checked="value === 'N'"/> No
    </label>
    <label class="btn btn-default"
           @click="updateValue('')"
           :class="{'active': isNA}">
      <input type="radio" value=""
             :checked="isNA"/> N/A
    </label>
  </div>
</template>

<script>
  export default {
    name: 'yes-no-na-input',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: ['value'],
    computed: {
      isYes () {
        return this.value === 'Y'
      },
      isNA () {
        return this.value === null || this.value === ''
      }
    },
    methods: {
      updateValue (value) {
        this.$emit('change', value)
      }
    }
  }
</script>

<style scoped>
  .btn-default.active, .btn-default.active.focus, .btn-default.active:hover, .btn-default:active, .btn-default:hover, .open>.btn-default.dropdown-toggle {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
  }
</style>



// WEBPACK FOOTER //
// src/js/components/YesNoNaButtonGroupComponent.vue